import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";

// Canonicalize hostname: www.mytharion.app → mytharion.app.
// This runs BEFORE the app mounts so that the Emergent OAuth consent screen
// (which derives the shown app name from the redirect URL's hostname) always
// gets the canonical domain and displays "Mytharion" instead of "Www".
if (typeof window !== "undefined" && window.location.hostname.startsWith("www.")) {
  const canonical = window.location.hostname.replace(/^www\./, "");
  window.location.replace(
    `${window.location.protocol}//${canonical}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);